import Fn from "jj-browser-fn";
import cookies from "./cookie";
import storage from "./storage";
import md5 from "js-md5";
import { footprint } from "@/req/operation";
const ProjFn = {
  ...Fn,
  cookies,
  storage,
  // 跳转游戏详情
  toGameDetail: (gameid, types, uid) => {
    window.App.$router.push({
      path: "/myGame/gameDetail",
      query: { id: gameid, type: types, uids: uid },
    });
  },
  // 跳转直播间
  toStudioRoom: (routePath, liveId, isCompetition) => {
    // 是否赛事直播
    if (isCompetition) {
      window.App.$router.push({
        path: "/competition",
        query: { type: "1", id: liveId },
      });
    } else {
      window.App.$router.push({
        path: "/studio",
        query: { type: "1", id: liveId },
      });
    }
  },
  // 转换成时间
  toTimes: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m, s] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds()),
      ];
      return `${Y}-${M}-${D} ${h}:${m}:${s}`;
    }
  },
  toDates: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `${num}` : num);
      const [Y, M, D, h, m, s] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds()),
      ];
      return `${M}月${D}日`;
    }
  },
  toDateSymbol: (time) => {
    if (!time) {
      return "";
    } else {
      const date = new Date(time * 1000);
      const dateNumFun = (num) => (num < 10 ? `0${num}` : num);
      const [Y, M, D, h, m, s] = [
        date.getFullYear(),
        dateNumFun(date.getMonth() + 1),
        dateNumFun(date.getDate()),
        dateNumFun(date.getHours()),
        dateNumFun(date.getMinutes()),
        dateNumFun(date.getSeconds()),
      ];
      return `${M}-${D} ${h}:${m}`;
    }
  },
  // 超出3字符省略号
  ellipsis: (value: any) => {
    if (!value) return "";
    if (value.length > 3) {
      return value.slice(0, 3) + "...";
    }
    return value;
  },
  // 游戏热度
  hotEllipsis: (item: any) => {
    const value = item + "";
    if (!value) return "";
    if (value.length == 5) {
      return value.slice(0, 1) + "w+";
    }
    if (value.length == 6) {
      return value.slice(0, 2) + "w+";
    }
    if (value.length >= 7) {
      return value.slice(0, 0) + "99w+";
    }
    return value;
  },
  random: () => {
    const chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    let res = "";
    for (let i = 0; i < 32; i++) {
      const id = Math.ceil(Math.random() * 35);
      res += chars[id];
    }
    return res;
  },
  // 接口验签
  toSign: (obj, url) => {
    // 按照升序排序obj属性
    const sortObj = obj;
    // 生成随机数
    const chars = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ];
    let resNum = "";
    for (let i = 0; i < 32; i++) {
      const id = Math.ceil(Math.random() * 35);
      resNum += chars[id];
    }
    const newkey = Object.keys(sortObj).sort();
    const newObj: any = {};
    newkey.forEach((item, i) => {
      // 遍历newkey数组
      newObj[newkey[i]] = sortObj[newkey[i]];
      // 向新创建的对象中按照排好的顺序依次增加键值对
    });
    const token = newObj.token;
    delete newObj.token;
    const keyArr = new Array();
    for (const y in newObj) {
      if (true) {
        const x = newObj[y];
        keyArr.push(x);
      }
    }
    newObj.rqtime = Date.parse(String(new Date()));
    newObj.rqrandom = resNum;
    if (
      (url && url.indexOf("/ShunWan/getList") >= 0) ||
      url.indexOf("/ShunWan/getAllVersionAndTagList") >= 0 ||
      url.indexOf("/ShunWan/getTimeSection") >= 0
    ) {
      keyArr.push("togkp5gvsgtNd20EfiDx2NOhLPFTOFuN"); // key
    } else {
      keyArr.push("7PZJImoeAE5Dnjb6pCYu8Ja5Buhb2urL"); // key
    }

    keyArr.push(newObj.rqtime);
    keyArr.push(newObj.rqrandom);
    let sginStr = "";
    keyArr.filter((item) => {
      if (typeof item == "object") {
        return JSON.stringify(item);
      }
    });
    // 将字符串按验签规则拼接
    for (const y in keyArr) {
      if (true) {
        if (typeof keyArr[y] == "object" && keyArr[y] != null) {
          sginStr = JSON.stringify(keyArr[y]);
        } else if (keyArr[y] == undefined || keyArr[y] == null) {
          sginStr = sginStr;
        } else {
          sginStr = sginStr + keyArr[y];
        }
      }
    }
    // const keySign = keyArr.join("");
    newObj.sign = md5(sginStr);
    newObj.token = token;
    return newObj;
  },
  // 埋点用户行为记录
  // module_index 模块索引编号
  // deed   1=打开,2=点击,3=输入,4=关闭,10=返回
  // relation_id  操作关联的ID
  userRecord: async (moduleIndex, deed, relationId) => {
    return false;
    const obj = {
      module_index: moduleIndex ? moduleIndex : "",
      deed: deed ? deed : "",
      relation_id: relationId ? relationId : "",
    };
    const res = await footprint(obj);
  },
};

export default ProjFn;
